import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { JuridicaService } from '../../../service/JuridicaService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AccionistaSocios } from '../AccionistaSocios';
import { JuridicaPep } from '../../../models/ficha/JuridicaPep';
import { PepAfinidad } from '../common/PepAfinidad';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const AccionistasPep = ({ toast, back, next, id, permss, soloLectura, catalogos }) => {

    const omodel = new JuridicaPep({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues });
    const juridicaSrv = new JuridicaService();
    const [esPep, setEsPep] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [relacionPep, setRelacionPep] = useState(false);
    const { inText, inCalendar, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });

    useEffect(() => {
        editarFicha();
        // eslint-disable-next-line
    }, [id]);

    const editarFicha = () => {
        setIsLoading(true);
        juridicaSrv.consultarJuridica(id, 'seccion3').then(res => {
            if (!res.data.juridica) {
                return;
            }
            const _juridica = res.data.juridica;

            _juridica.fecha_nombramiento_pep = generic.stringToDate(_juridica.fecha_nombramiento_pep);
            _juridica.fecha_dejo_pep = generic.stringToDate(_juridica.fecha_dejo_pep);
            setEsPep(_juridica.pep?.cat_id);
            _juridica.fecha_vinculo_pep = generic.stringToDate(_juridica.fecha_vinculo_pep);
            _juridica.fecha_culminacion_pep = generic.stringToDate(_juridica.fecha_culminacion_pep);
            setRelacionPep(_juridica.relacion_pep?.cat_id);
            reset(generic.renewValues(_juridica, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.seccion = 'seccion3';
        if (esPep) {
            data.fecha_nombramiento_pep = generic.dateToString(data.fecha_nombramiento_pep);
            if (data.fecha_dejo_pep) {
                data.fecha_dejo_pep = generic.dateToString(data.fecha_dejo_pep);
            }
        } else {
            delete data.fecha_nombramiento_pep;
            delete data.fecha_dejo_pep;
        }
        if (relacionPep) {
            data.fecha_vinculo_pep = generic.dateToString(data.fecha_vinculo_pep);
            if (data.fecha_culminacion_pep) {
                data.fecha_culminacion_pep = generic.dateToString(data.fecha_culminacion_pep);
            }
        } else {
            delete data.fecha_vinculo_pep;
            delete data.fecha_culminacion_pep;
        }
        juridicaSrv.editarJuridica(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePep = (e, _soloPep) => {
        if (_soloPep) {
            setEsPep(e.value?.cat_id);
            setValue('nombre_pep', '');
            setValue('cargo_pep', '');
            setValue('institucion_trabaja_pep', '');
            setValue('fecha_nombramiento_pep', null);
            setValue('fecha_dejo_pep', null);
        } else {
            setRelacionPep(e.value?.cat_id);
            setValue('relacion_vinculo_pep', '');
            setValue('nombre_vinculo_pep', '');
            setValue('cargo_vinculo_pep', '');
            setValue('institucion_vinculo_pep', '');
            setValue('fecha_vinculo_pep', null);
            setValue('fecha_culminacion_pep', null);
        }
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <Panel header={generic.renderPanelHeader('6', 'INFORMACIÓN DE LOS ACCIONISTAS/SOCIOS', 'pi pi-users')} className="panel-ficha shadow-1 mb-4">
                <AccionistaSocios toast={toast} tipo="juridica" id={id} permss={permss} soloLectura={soloLectura} />
            </Panel>

            <form id="accionistasPepForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header={generic.renderPanelHeader('7', 'PERSONA EXPUESTA POLÍTICAMENTE (PEP) - DESCRIBIR EN EL CASO QUE SOCIOS, ACCIONISTAS O DIRECTIVOS OCUPEN ESTOS CARGOS', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-3">
                        <div className="flex align-items-center gap-2 mb-2">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Definición de PEP</span>
                        </div>
                        {omodel.strPep}
                    </div>

                    <Card className="mb-4 section-card">
                        <div className="formgrid grid">
                            {inDrop('pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: true }, 12)}
                            {esPep && (
                                <>
                                    {inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                                    {inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}

                                    {inText('institucion_trabaja_pep', { icon: 'pi pi-building' }, 4)}
                                    {inCalendar('fecha_nombramiento_pep', {}, 4)}
                                    {inCalendar('fecha_dejo_pep', { obl: true }, 4)}
                                </>
                            )}
                        </div>
                    </Card>

                    <div className="col-12 mb-3 px-0">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-users text-primary"></i>
                                FAMILIARES O RELACIONADOS
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    <PepAfinidad tipo="juridica" id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />

                    <div className="col-12 mt-4 mb-3 px-0">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-share-alt text-primary"></i>
                                VÍNCULO CON UN PEP
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    <Card className="mb-3 section-card">
                        <div className="formgrid grid">
                            {inDrop('relacion_pep', generic.estadosSiNo, { lab: omodel.optionLabel, chn: onChangePep, val: false }, 12)}
                            {relacionPep && (
                                <>
                                    {inText('relacion_vinculo_pep', { icon: 'pi pi-user' }, 4)}
                                    {inText('nombre_vinculo_pep', { icon: 'pi pi-user' }, 4)}

                                    {inText('cargo_vinculo_pep', { icon: 'pi pi-briefcase' }, 4)}
                                    {inText('institucion_vinculo_pep', { icon: 'pi pi-building' }, 4)}
                                    {inCalendar('fecha_vinculo_pep', {}, 4)}
                                    {inCalendar('fecha_culminacion_pep', {}, 4)}
                                </>
                            )}
                        </div>
                    </Card>
                </Panel>

                <BottomActionBar formId="accionistasPepForm" onPrev={back} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </>
    );
}
